import { gql } from "lib/apolloClient";

export const projectFieldsFragment = {
  projectFieldsDetails: gql`
    fragment projectFieldsDetails on Project {
      id
      fields(filters: $filters) {
        id
        uid
        value
      }
    }
  `,
};

export const projectFragments = {
  portfolioProjectInfoFragment: gql`
    fragment portfolioProjectInfo on Project {
      id
      status
    }
  `,
};

export const studentFragments = {
  studentInfoFragment: gql`
    fragment studentInfo on Student {
      id
      firstName
      middleName
      lastName
      profileImage
      sourceId
      type
      preferredName
      suffix
      pronouns
    }
  `,
};
